import useLabels from "../../hooks/useLabels";
import { StickyNotesModal } from "../Generic";

const NotesModal = ({
  isOpen,
  onClose = () => null,
}) => {
  const [getLabel] = useLabels();

  return (
    isOpen && (
      <StickyNotesModal isOpen={isOpen} onClose={onClose} >
        <div className={"confirmation-modal-container"}>
          <h4>{getLabel("wineriesModalSelector")}</h4>
        </div>
      </StickyNotesModal>)
  );
};

export default NotesModal;